/* Sensei Shopify adapter — no API keys, Admin API, JSON image uploads or theme
   cart-drawer interception. Exact origin + source + per-instance channel checks.
   Tok kao na uzoru: galerija + dugme → fotografija → mockup na istom mestu →
   boja i miris → svaki komad posebno ide u korpu → kockice „Kupi 2, treći gratis“
   prate šta je već u korpi. */
(function(){
  'use strict';
  const normalize=value=>String(value??'').normalize('NFKD').replace(/[̀-ͯ]/g,'').toLowerCase().replace(/[^a-z0-9]/g,'');
  function optionIndex(config,kind){
    const setting=config[kind+'Option'];
    if(setting==='0')return -1;
    if(setting!=='auto'){
      const index=Number(setting)-1;
      if(!Number.isInteger(index)||index<0||index>=config.optionNames.length)throw new Error('Povezivanje opcija nije podešeno.');
      return index;
    }
    const names=kind==='color'?['boja','bojakucista','color','colour']:['miris','scent','fragrance'];
    return config.optionNames.findIndex(name=>names.includes(normalize(name)));
  }
  function resolveVariant(config,state,extra={}){
    const color=optionIndex(config,'color'),scent=optionIndex(config,'scent');
    if(color>=0&&color===scent)throw new Error('Boja i parfem ne mogu biti ista Shopify opcija.');
    const alias=value=>config.aliases[value]??value;
    const wanted=config.optionNames.map((_,index)=>index===color?alias(state.color):index===scent?alias(state.scent):extra[index]);
    return config.variants.find(v=>v.options.length===wanted.length&&v.options.every((value,index)=>normalize(value)===normalize(wanted[index])))||null;
  }
  if(typeof module==='object')module.exports={normalize,optionIndex,resolveVariant};
  if(typeof window==='undefined'||customElements.get('sensei-shopify'))return;
  const wait=ms=>new Promise(r=>setTimeout(r,ms));
  /* boja kućišta → hex, za stavke bez sačuvanog _sensei_boja (stari engleski nazivi takođe) */
  const FRAME={'crna':'#202326','siva':'#A8AAA8','svetloplava':'#9DB8CC','babyblue':'#9DB8CC','tamnoplava':'#243F9C','galacticblue':'#243F9C','svetloroze':'#E5BECD','babypink':'#E5BECD','crvena':'#D92335','zuta':'#EDC510','narandzasta':'#F15A25','zelena':'#687247','zlatna':'#C99836','bordo':'#6D214A','burgundy':'#6D214A','ljubicasta':'#915C9C','purple':'#915C9C'};
  const frameHex=p=>{const h=String(p['_sensei_boja']||'');if(/^#[0-9a-f]{3,8}$/i.test(h))return h;return FRAME[normalize(p['Boja kućišta'])]||'#A8AAA8';};
  const esc=v=>String(v??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

  class SenseiShopify extends HTMLElement{
    connectedCallback(){
      if(this.initialized)return;this.initialized=true;this.abort=new AbortController();
      this.q=selector=>this.querySelector(selector);
      this.frame=this.q('[data-frame]');this.form=this.q('[data-order]');this.picker=this.q('[data-ss-picker]');
      this.channel=crypto.randomUUID();this.busy=false;this.latest=null;this.pending=null;this.injecting=false;this.cartCount=null;this.pieceCount=Number(this.dataset.pieces)||0;
      try{this.txt=JSON.parse(this.q('[data-ss-text]').textContent);}catch(e){this.txt={};}
      try{
        this.config=JSON.parse(this.q('[data-config]').textContent);
        this.config.aliases=JSON.parse(this.config.aliases||'{}');
        if(!this.config.aliases||Array.isArray(this.config.aliases)||typeof this.config.aliases!=='object'||Object.values(this.config.aliases).some(v=>typeof v!=='string'))throw new Error('Neispravan JSON');
        /* "inline" = konfigurator se gradi u srcdoc okviru iz iste teme.
           Shopify ne dozvoljava iframe ni na assets HTML (sandbox) ni na
           storefront stranu (frame-ancestors none), pa okvir pravimo lokalno. */
        let url=null;
        if(this.config.url==='inline'){
          this.origin=location.origin;
        }else{
          url=new URL(this.config.url);
          if(url.protocol!=='https:'||url.username||url.password)throw new Error('URL');
          this.origin=url.origin;url.searchParams.set('parent',location.origin);url.searchParams.set('channel',this.channel);url.searchParams.set('embed','1');
        }
        const listen=(target,type,handler,options={})=>target.addEventListener(type,handler,{...options,signal:this.abort.signal});
        listen(window,'message',event=>this.receive(event));
        listen(this.frame,'load',()=>{this.post('sync');this.updatePurchase();try{const ro=new this.frame.contentWindow.ResizeObserver(()=>this.placeBundle());const c=this.frame.contentDocument.querySelector('.sp-controls');if(c)ro.observe(c);}catch(e){}});
        listen(window,'resize',()=>this.placeBundle());
        listen(window,'pageshow',event=>{this.busy=false;if(this.form)this.form.inert=false;this.post('export-release');this.updatePurchase();if(event.persisted)this.loadCart();});
        if(this.form){
          const color=optionIndex(this.config,'color'),scent=optionIndex(this.config,'scent');
          if(color>=0&&color===scent)throw new Error('options');
          this.querySelectorAll('[data-option]').forEach(select=>{
            const index=Number(select.dataset.option);
            select.closest('label').hidden=index===color||index===scent||select.options.length===1;
            listen(select,'change',()=>this.updatePurchase());
          });
          listen(this.form,'submit',event=>this.submit(event),{capture:true});
        }
        /* dugme ispod galerije i prazne kockice odmah otvaraju izbor fotografije */
        listen(this,'click',event=>{const b=event.target.closest('[data-ss-pick]');if(b&&this.contains(b)){event.preventDefault();if(b.classList.contains('ss-box')&&this.unsaved()){this.addFirst();return;}this.openPicker();}});
        if(this.picker)listen(this.picker,'change',()=>this.onPicked());
        if(url){this.frame.src=url.href;}
        else{this.frame.srcdoc=this.buildInlineDoc();}
        this.connectionTimer=setTimeout(()=>this.connection('Konfigurator nije odgovorio. Osveži stranicu ili nam se javi.',true),30000);
        this.updatePurchase();this.loadCart();this.takeHandoff();this.showOccasion();
        /* ?dizajn=1 bez sačuvanog dizajna (drugi uređaj, obrisan pregledač): posle 7 s vrati običnu početnu */
        if(document.documentElement.classList.contains('ss-nastavi')){
          /* iPhone/Safari ume da ne vrati nacrt iz pregledača — tada se dizajn uzima iz poslednjeg komada u korpi */
          setTimeout(()=>{if(this.dataset.stage!=='studio')this.restoreFromCart();},2500);
          setTimeout(()=>{if(this.dataset.stage!=='studio'&&!this.injecting)document.documentElement.classList.remove('ss-nastavi');},15000);
        }
      }catch(error){this.connection('Konfigurator još nije podešen. Proveri URL i nazive opcija u podešavanjima sekcije.',true);}
    }
    status(text,error=false){const st=this.q('[data-order-status]');if(st){st.hidden=!text;st.textContent=text||'';st.dataset.error=String(error);}}
    /* ---------- galerija ↔ konfigurator ---------- */
    placeBundle(){
      const b=this.q('.ss-b2g1');if(!b)return;
      let d=null;try{d=this.frame.contentDocument;}catch(e){}
      const slot=d&&d.querySelector('[data-ss-bundle-slot]');
      /* dok je otvoren „Podesi kadar“, blok „Kupi 2, treći gratis“ se ne vidi (ne preklapa prozor, ne pojavljuje se ispod njega) */
      const dlg=d&&d.getElementById('sp-crop-dialog');
      if(dlg&&!this._dlgObs){this._dlgObs=new MutationObserver(()=>this.placeBundle());this._dlgObs.observe(dlg,{attributes:true,attributeFilter:['open']});}
      b.classList.toggle('is-cropping',!!(dlg&&dlg.open));
      const clear=()=>{b.classList.remove('is-docked');b.style.left=b.style.top=b.style.width='';if(slot)slot.style.height='0px';};
      if(this.dataset.stage!=='studio'||!slot||!slot.getBoundingClientRect().width)return clear();
      b.classList.add('is-docked');
      const w=slot.getBoundingClientRect().width;b.style.width=Math.round(w)+'px';
      /* mesto u okviru dobije visinu bloka, pa okvir sam poraste */
      const hgt=b.offsetHeight;if(Math.abs((parseFloat(slot.style.height)||0)-(hgt+14))>1)slot.style.height=(hgt+14)+'px';
      const sr=slot.getBoundingClientRect(),fr=this.frame.getBoundingClientRect(),hr=this.getBoundingClientRect();
      b.style.left=Math.round(fr.left-hr.left+sr.left)+'px';
      b.style.top=Math.round(fr.top-hr.top+sr.top+8)+'px';
    }
    showStudio(on,scroll){
      const was=this.dataset.stage==='studio';
      this.dataset.stage=on?'studio':'intro';
      requestAnimationFrame?setTimeout(()=>this.placeBundle(),60):this.placeBundle();
      if(on&&scroll){
        const stage=this.q('.ss-stage');if(!stage)return;
        const sticky=this.stickyTop();
        const top=stage.getBoundingClientRect().top;
        if(!was||top<0||top>window.innerHeight*0.5)window.scrollTo({top:Math.max(0,top+window.scrollY-sticky-8)});
      }
    }
    /* visina zalepljenog zaglavlja (lepljiv je omotač sekcije, ne sam header) */
    stickyTop(){
      let max=0;
      document.querySelectorAll('body > *').forEach(el=>{
        const pos=getComputedStyle(el).position;if(!/sticky|fixed/.test(pos))return;
        const r=el.getBoundingClientRect();if(r.height>0&&r.height<320&&r.top<=1)max=Math.max(max,r.bottom);
      });
      /* traka obaveštenja je zalepljena na vrhu ekrana (fixed) */
      const an=document.querySelector('.announcement');if(an&&getComputedStyle(an).position==='fixed')max=Math.max(max,an.getBoundingClientRect().bottom);
      return max;
    }
    /* „Podesi kadar“: prozor visok koliko je vidljivo ispod zaglavlja, i pomeren tačno ispod njega */
    fitCrop(){
      let d=null;try{d=this.frame.contentDocument;}catch(e){}if(!d)return;
      const dlg=d.getElementById('sp-crop-dialog');if(!dlg||!dlg.open)return;
      const top=this.stickyTop(),avail=Math.max(360,window.innerHeight-top-16);
      d.documentElement.style.setProperty('--ss-avail',avail+'px');
      setTimeout(()=>{
        const r=dlg.getBoundingClientRect(),fr=this.frame.getBoundingClientRect();
        window.scrollTo({top:Math.max(0,fr.top+r.top+window.scrollY-top-8),behavior:'instant'});
      },30);
    }
    async shareDesign(){
      if(this.sharing)return;this.sharing=true;
      let d=null;try{d=this.frame.contentDocument;}catch(e){}
      const btn=d&&d.querySelector('[data-ss-share]');if(btn)btn.classList.add('is-busy');
      const vw=new URLSearchParams(location.search).get('view');const url=location.origin+location.pathname+(vw?'?view='+encodeURIComponent(vw):'');
      const t=this.txt;
      try{
        let file=null;
        try{
          const shot=await this.frame.contentWindow.SenseiConfigurator.snapshot();
          file=await this.shareCard(shot);
        }catch(e){file=null;}
        if(window.SENSEI&&window.SENSEI.share)window.SENSEI.share({title:t.shareTitle||'Moj Sensei',text:t.shareText||'',url,file});
      }finally{this.sharing=false;if(btn)btn.classList.remove('is-busy');}
    }
    /* kartica 1080×1350: ljubičasta pozadina, prikaz proizvoda, poziv na sajt */
    async shareCard(shot){
      const img=await createImageBitmap(shot);
      const W=1080,H=1350,c=document.createElement('canvas');c.width=W;c.height=H;const g=c.getContext('2d');
      const bg=g.createLinearGradient(0,0,W,H);bg.addColorStop(0,'#8b5dbe');bg.addColorStop(1,'#3b1d5e');g.fillStyle=bg;g.fillRect(0,0,W,H);
      const t=this.txt;
      g.fillStyle='#e6d8fb';g.font='600 30px Gabarito,Arial,sans-serif';g.textAlign='center';g.fillText((t.shareKicker||'PERSONALIZOVANI PARFEM ZA AUTO').toUpperCase(),W/2,110);
      g.fillStyle='#fff';g.font='800 84px Gabarito,Arial,sans-serif';g.fillText(t.shareTitle||'Moj Sensei',W/2,205);
      const x=70,y=260,s=W-140,r=48;
      const panel=g.createRadialGradient(x+s*.4,y+s*.3,10,x+s/2,y+s/2,s*.75);panel.addColorStop(0,'#fcfbf8');panel.addColorStop(1,'#e5e6df');
      g.save();g.beginPath();g.roundRect(x,y,s,s,r);g.fillStyle=panel;g.fill();g.clip();
      const k=Math.min(s/img.width,s/img.height);g.drawImage(img,x+(s-img.width*k)/2,y+(s-img.height*k)/2,img.width*k,img.height*k);g.restore();
      g.fillStyle='#f5c446';g.font='800 40px Gabarito,Arial,sans-serif';g.fillText(t.shareCta||'Napravi svoj',W/2,1250);
      g.fillStyle='#fff';g.font='500 32px Gabarito,Arial,sans-serif';g.fillText(location.host.replace(/^www\./,''),W/2,1300);
      const blob=await new Promise(res=>c.toBlob(res,'image/jpeg',.9));
      return new File([blob],'moj-sensei.jpg',{type:'image/jpeg'});
    }
    /* meni „Porodica / Ljubimac / Dete / Vas dvoje“ → kratak naslov iznad slika */
    showOccasion(){
      const key=new URLSearchParams(location.search).get('za');const box=this.q('[data-ss-occasion]');
      let map=this.txt.occasions;if(typeof map==='string'){try{map=JSON.parse(map);}catch(e){map=null;}}
      const o=key&&map&&map[key.replace(/-/g,'_')];if(!box||!o||!o.title)return;
      this.q('[data-ss-occ-title]').textContent=o.title;this.q('[data-ss-occ-sub]').textContent=o.sub||'';box.hidden=false;
    }
    openPicker(){if(this.busy||this.injecting)return;if(this.picker)this.picker.click();}
    async onPicked(){
      const f=this.picker.files&&this.picker.files[0];if(!f)return;
      /* kopija u memoriji pre brisanja polja: Safari inače ume da „izgubi“ fajl iz galerije */
      let file=f;
      try{const buf=await f.arrayBuffer();file=new File([buf],f.name||'fotografija.jpg',{type:f.type||'',lastModified:f.lastModified||Date.now()});}catch(e){}
      this.picker.value='';
      this.status('');
      await this.sendPhoto(file);
    }
    /* fotografija ide u isti konfigurator, kao da ju je kupac tamo izabrao */
    /* boja kućišta i miris (svojstva komada iz korpe) → konfigurator */
    applyLook(p){
      let d=null;try{d=this.frame.contentDocument;}catch(e){}if(!d||!p)return;
      const boja=String(p['Boja kućišta']||'').trim().toLowerCase();
      if(boja){const b=[...d.querySelectorAll('.sp-colors button')].find(x=>String(x.getAttribute('aria-label')||x.title||x.dataset.name||'').trim().toLowerCase()===boja);if(b)b.click();}
      const miris=String(p['Parfem']||p['Miris']||'');const sel=d.querySelector('#sp-scent');
      if(sel&&miris&&[...sel.options].some(o=>o.value===miris)){sel.value=miris;sel.dispatchEvent(new Event('change',{bubbles:true}));}
    }
    async lookFromCart(){
      try{
        const cart=await (await fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart.js',{headers:{Accept:'application/json'}})).json();
        const it=(cart.items||[]).find(i=>i.properties&&(i.properties['Pripremljeni kadar']||i.properties['Radna fotografija']));
        if(it)this.applyLook(it.properties);
      }catch(e){}
    }
    async restoreFromCart(){
      if(this._fromCart||this.dataset.stage==='studio'||this.injecting)return;this._fromCart=true;
      const done=()=>document.documentElement.classList.remove('ss-nastavi');
      try{
        const cart=await (await fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart.js',{headers:{Accept:'application/json'}})).json();
        const it=(cart.items||[]).find(i=>i.properties&&(i.properties['Pripremljeni kadar']||i.properties['Radna fotografija']));
        if(!it)return done();
        const p=it.properties,url=String(p['Pripremljeni kadar']||p['Radna fotografija']);
        const blob=await (await fetch(url)).blob();
        if(this.dataset.stage==='studio')return done();
        await this.sendPhoto(new File([blob],'tvoj-sensei.jpg',{type:blob.type||'image/jpeg',lastModified:Date.now()}));
        if(this.dataset.stage!=='studio')return done();
        /* ista boja kućišta i isti miris kao u korpi */
        this.applyLook(p);
        try{const u=new URL(location.href);u.searchParams.delete('dizajn');history.replaceState(history.state,'',u.pathname+u.search+u.hash);}catch(e){}
      }catch(e){}
      done();
    }
    async sendPhoto(file){
      this.injecting=true;this.updatePurchase();
      try{
        let root=null;
        for(let k=0;k<160;k++){
          const w=this.frame.contentWindow,d=this.frame.contentDocument;
          root=d&&d.getElementById('sensei-studio');
          if(w&&d&&w.SenseiConfigurator&&d.querySelector('.sp-file')&&root&&root.dataset.loading!=='true')break;
          await wait(250);
        }
        const w=this.frame.contentWindow,d=this.frame.contentDocument;
        const input=d&&d.querySelector('.sp-file');
        if(!w||!input)throw new Error(this.txt.photoError||'Fotografiju nismo uspeli da otvorimo. Pokušaj ponovo.');
        const before=this.latest?.photoId||'';
        const dt=new w.DataTransfer();dt.items.add(new w.File([file],file.name,{type:file.type,lastModified:file.lastModified}));
        input.files=dt.files;input.dispatchEvent(new w.Event('change',{bubbles:true}));
        /* čekamo da konfigurator pokaže mockup ili javi grešku */
        for(let k=0;k<600;k++){
          await wait(150);
          const step=root?.dataset.step;
          const proc=d.querySelector('.sp-processing');
          if(proc&&proc.dataset.failed==='true'&&!proc.hidden)throw new Error(this.txt.photoError||'Fotografiju nismo uspeli da otvorimo. Pokušaj ponovo.');
          if(step==='processing'||root?.dataset.loading==='true')continue;
          if(step==='preview'&&(this.latest?.photoId!==before||k>20)){this.showStudio(true,true);return;}
          if(step==='upload'){
            const err=d.querySelector('.sp-error');
            throw new Error((err&&!err.hidden&&err.textContent)||this.txt.photoError||'Fotografiju nismo uspeli da otvorimo. Pokušaj ponovo.');
          }
        }
      }catch(error){
        if(!this.latest?.photoId)this.showStudio(false);
        this.status(error.message,true);
      }finally{
        this.injecting=false;this.updatePurchase();
      }
    }
    /* ---------- kockice: prate šta je u korpi ---------- */
    async loadCart(){
      try{
        const cart=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json());
        this.cartCount=cart.item_count;this.renderBoxes(cart);this.syncHeader(cart.item_count);
        return cart;
      }catch(e){return null;}
    }
    renderBoxes(cart){
      const row=this.q('[data-ss-boxes]');if(!row)return;
      const pieces=[];
      /* Shopify ređa najnovije prvo — kockice idu redom kojim su komadi dodati */
      (cart.items||[]).slice().reverse().forEach(item=>{
        if(String(item.product_id)!==String(this.config.productId))return;
        const p=item.properties||{};
        const img=p['Pripremljeni kadar']||item.image||'';
        const frame=frameHex(p);
        for(let i=0;i<item.quantity;i++)pieces.push({img,label:p['Parfem']||p['Miris']||'',frame});
      });
      this.pieceCount=pieces.length;this.toggleAttribute('data-has-pieces',pieces.length>0);
      const t=this.txt,ord=['1.','2.',t.boxFree||'GRATIS'];
      const box=n=>{
        const piece=pieces[n],free=n===2;
        if(piece){
          const extra=n===2&&pieces.length>3?'<span class="ss-box__more">+'+(pieces.length-3)+'</span>':'';
          return '<div class="ss-box is-filled'+(free?' ss-box--free':'')+'" style="--frame:'+esc(piece.frame)+'"><span class="ss-box__img"><img src="'+esc(piece.img)+'" alt="" loading="lazy"></span><span class="ss-box__t">'+esc(piece.label)+'</span>'+extra+'</div>';
        }
        return '<button type="button" class="ss-box'+(free?' ss-box--free':'')+'" data-ss-pick><span class="ss-box__ph">'+esc(t.boxAdd||'Dodaj')+'<b>'+esc(ord[n])+'</b>'+esc(t.boxPiece||'komad')+'</span></button>';
      };
      row.innerHTML=box(0)+'<span class="ss-op" aria-hidden="true">+</span>'+box(1)+'<span class="ss-op" aria-hidden="true">=</span>'+box(2);
      setTimeout(()=>this.placeBundle(),30);
      this.syncFrameBuy();
    }
    syncHeader(count){
      if(typeof count!=='number')return;
      document.querySelectorAll('.cart-link,a[href$="/cart"].small-caps').forEach(a=>{if(/\(\d+\)/.test(a.textContent))a.textContent=a.textContent.replace(/\(\d+\)/,'('+count+')');});
      if(window.SENSEI)window.SENSEI.cartCount=count;
    }
    /* ---------- dugmad u konfiguratoru ---------- */
    inFrameBuy(kind){
      if(this.busy||this.injecting||!this.latest?.ready)return;
      if(!this.latest.scent){this.needScent();return;}
      this.form.requestSubmit();
    }
    needScent(){
      let d=null;try{d=this.frame.contentDocument;}catch(e){}if(!d)return;
      const box=d.querySelector('.sp-scent'),sel=d.getElementById('sp-scent'),hint=d.querySelector('[data-ss-inbuy-hint]');
      if(hint)hint.hidden=false;
      if(box){box.classList.remove('ss-need');void box.offsetWidth;box.classList.add('ss-need');}
      if(sel){
        try{sel.focus({preventScroll:true});}catch(e){}
        const go=()=>{const r=sel.getBoundingClientRect(),fr=this.frame.getBoundingClientRect();window.scrollTo({top:Math.max(0,fr.top+r.top+window.scrollY-this.stickyTop()-70)});};
        go();setTimeout(go,60);
      }
    }
    /* trenutni komad (učitana slika) još nije u korpi */
    unsaved(){const s=this.latest;return !!(s&&s.ready&&s.photoId)&&s.photoId!==this.savedPhoto;}
    addFirst(){
      const m=this.q('[data-ss-bundle-msg]');
      if(m){m.hidden=false;m.classList.remove('is-shake');void m.offsetWidth;m.classList.add('is-shake');}
      this.placeBundle();
      let d=null;try{d=this.frame.contentDocument;}catch(e){}
      const c=d&&d.querySelector('[data-ss-inbuy="cart"]');
      if(c){c.classList.remove('ss-pulse');void c.offsetWidth;c.classList.add('ss-pulse');}
    }
    hideAddFirst(){const m=this.q('[data-ss-bundle-msg]');if(m&&!m.hidden){m.hidden=true;this.placeBundle();}}
    /* „Kupi 2, treći gratis“: kad su dva komada već u korpi, sledeći je besplatan */
    isFreeNext(){return this.pieceCount===2;}
    syncFrameBuy(){
      let d=null;try{d=this.frame.contentDocument;}catch(e){}if(!d)return;
      const cart=d.querySelector('[data-ss-inbuy="cart"]'),hint=d.querySelector('[data-ss-inbuy-hint]');
      let variant=null;try{variant=this.variant();}catch(e){}
      const on=!this.busy&&!this.injecting&&!!this.latest?.ready&&(!this.latest.scent||!!variant?.available);
      const v=variant||this.config.variants[0]||{};
      if(cart){
        cart.disabled=!on;
        if(this.busy)cart.textContent=this.txt.adding||'Dodajemo…';
        else if(this.isFreeNext())cart.innerHTML='<span>'+esc(this.txt.add||'Dodaj u korpu')+'</span>'+(v.price?' <s>'+esc(v.price)+'</s>':'')+' <b class="is-free">'+esc(this.txt.freePrice||'BESPLATNO')+'</b>';
        else cart.innerHTML='<span>'+esc(this.txt.add||'Dodaj u korpu')+'</span>'+(v.compare?' <s>'+esc(v.compare)+'</s>':'')+(v.price?' <b>'+esc(v.price)+'</b>':'');
      }
      if(this.latest?.scent){if(hint)hint.hidden=true;const box=d.querySelector('.sp-scent');if(box)box.classList.remove('ss-need');}
    }
    buildInlineDoc(channel=this.channel){
      const tpl=this.querySelector('template[data-app]');
      const meta=JSON.parse(this.querySelector('[data-assets]').textContent);
      const skripte=meta.scripts.map(src=>'<script defer src="'+src+'"></script>').join('');
      return '<!doctype html><html lang="sr-Latn" class="ss-main"><head><meta charset="utf-8">'
        + '<meta name="viewport" content="width=device-width,initial-scale=1">'
        + '<link rel="stylesheet" href="'+meta.styles+'">'
        + '<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Gabarito:wght@400;500;600;700;800;900&display=swap">'
        + '<style>#sensei-studio,#sensei-studio *:not(svg):not(svg *){font-family:"Gabarito",Arial,Helvetica,sans-serif!important}#sensei-studio h3{font-weight:700}</style>'
        + '<style>'
        + '.ss-main .sp-intake{display:none!important}'
        /* bez „učitavanja“: dok se nova slika priprema, ostaje prethodni prikaz; ekran sa procentima se ne prikazuje */
        + '.ss-main #sensei-studio .sp-processing{display:none!important}'
        + '.ss-main #sensei-studio[data-step="processing"] .sp-layout[hidden]{display:grid!important}'
        + '.ss-main #sensei-studio .sp-ai-note{display:none!important}'
        + '.ss-main #sensei-studio .sp-share{position:absolute;top:10px;right:10px;z-index:6;display:inline-flex;align-items:center;gap:6px;min-height:34px;padding:6px 13px;border:1.5px solid #8b5dbe;border-radius:999px;background:rgba(255,255,255,.94);color:#5b2e8c;font-size:13px;font-weight:700;line-height:1;box-shadow:0 6px 16px -8px rgba(91,46,140,.6);cursor:pointer}'
        + '.ss-main #sensei-studio .sp-share svg{width:15px;height:15px;flex:none}'
        + '.ss-main #sensei-studio .sp-share.is-busy{opacity:.6}'
        + '.ss-main #sensei-studio .sp-preview{position:relative}.ss-main .sp-tabs{display:flex!important;position:absolute;top:10px;left:10px;z-index:6;width:auto;margin:0;padding:0;gap:0;background:none;border:0;box-shadow:none}'
        + '.ss-main .sp-tabs [data-view="crop"]{display:inline-flex;align-items:center;gap:6px;width:auto;flex:0 0 auto;min-height:34px;margin:0;padding:6px 13px;border:1px solid rgba(139,93,190,.42)!important;border-radius:999px!important;background:rgba(255,255,255,.92)!important;color:#5b2e8c!important;font-size:13px!important;font-weight:600!important;line-height:1;box-shadow:none;cursor:pointer}'
        + '.ss-main .sp-tabs [data-view="crop"]::before{content:"";flex:none;width:14px;height:14px;background-color:currentColor;-webkit-mask:url("data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22black%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cpath d=%22M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7%22/%3E%3Cpath d=%22M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4z%22/%3E%3C/svg%3E") center/contain no-repeat;mask:url("data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22black%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cpath d=%22M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7%22/%3E%3Cpath d=%22M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4z%22/%3E%3C/svg%3E") center/contain no-repeat}'
        + '.ss-main .sp-inbuy{display:grid!important;gap:10px;margin-top:12px}'
        + '.ss-main .sp-inbuy button{min-height:54px;border-radius:10px!important;font:inherit;font-size:15px;font-weight:700;text-transform:uppercase;letter-spacing:.03em;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:4px 7px;flex-wrap:wrap;padding:8px 12px}'
        + '.ss-main .sp-inbuy .sp-inbuy__now{border:0!important;background:#5b2e8c!important;color:#fff!important}'
        + '.ss-main .sp-inbuy .sp-inbuy__cart{border:0!important;background:#5b2e8c!important;color:#fff!important;min-height:58px!important;font-size:16px!important;box-shadow:0 10px 22px -10px rgba(91,46,140,.7)}'
        + '.ss-main .sp-inbuy .sp-inbuy__cart s{font-weight:500;opacity:.7}'
        + '.sp-inbuy button:disabled{opacity:.45;cursor:default}'
        + '.ss-main .sp-inbuy__hint{margin:0;text-align:center;font-size:14px;font-weight:600;color:#a02828}'
        + '.ss-main .sp-inbuy__ship{margin:2px 0 0;text-align:center;font-size:13px;color:#656560}'
        + '.ss-main .sp-inbuy__ship::before{content:"\\2022";color:#8b5dbe;margin-right:6px}'
        + '.ss-main .sp-caption .sp-change{display:inline-flex!important;align-items:center;gap:6px;min-height:36px!important;max-width:none!important;width:auto!important;margin:0!important;padding:6px 14px!important;background:#fff!important;border:1.5px solid #8b5dbe!important;border-radius:999px!important;color:#5b2e8c!important;font-size:13px!important;font-weight:700!important;opacity:1!important}'
        + '.ss-main .sp-caption .sp-change svg{width:16px;height:16px}'
        + '.ss-main #sensei-studio .sp-caption{justify-content:center}'
        + '.ss-main .sp-inbuy__slot{height:0}'
        + '.ss-main .sp-scent.ss-need select{outline:3px solid #a02828;outline-offset:2px}'
        + '@keyframes ssPulse{0%,100%{transform:none;box-shadow:none}30%{transform:scale(1.04);box-shadow:0 0 0 4px rgba(160,40,40,.35)}60%{transform:scale(.99)}}'
        + '.ss-main .sp-inbuy .ss-pulse{animation:ssPulse .7s ease 2}'
        + '.ss-main .sp-inbuy .sp-inbuy__cart b.is-free{color:#f5c446;font-weight:800;letter-spacing:.06em}'
        /* Podesi kadar — ljubičasti izgled brenda */
        + '.ss-main #sensei-studio .sp-crop-dialog{color-scheme:light;background:#fff;color:#2e2340;border:0;border-radius:20px;box-shadow:0 30px 80px -20px rgba(40,15,80,.55)}'
        + '.ss-main #sensei-studio .sp-crop-dialog::backdrop{background:rgba(35,15,60,.62)}'
        + '.ss-main #sensei-studio .sp-crop-dialog{max-height:var(--ss-avail,calc(100dvh - 24px))}'
        + '@media(max-width:580px){.ss-main #sensei-studio .sp-crop-square{max-width:min(100%,calc(var(--ss-avail,700px) * .44))}.ss-main #sensei-studio #sp-crop-help{margin:10px 18px 12px}.ss-main #sensei-studio .sp-crop-body{gap:10px}}'
        + '.ss-main #sensei-studio .sp-crop-header{padding:18px 20px 16px;background:linear-gradient(135deg,#8b5dbe,#5b2e8c);color:#fff}'
        + '.ss-main #sensei-studio .sp-crop-header .sp-step{color:#e6d8fb;font-weight:700}'
        + '.ss-main #sensei-studio .sp-crop-header h3{color:#fff;margin-top:4px}'
        + '.ss-main #sensei-studio .sp-crop-header [data-action=crop-close]{width:40px;height:40px;min-height:40px;padding:0;border:0;border-radius:50%;background:rgba(255,255,255,.18);color:#fff;font-size:22px;line-height:1}'
        + '.ss-main #sensei-studio #sp-crop-help{margin:14px 20px 16px;color:#6b5a80}'
        + '.ss-main #sensei-studio .sp-crop-square{box-shadow:0 0 0 3px #8b5dbe,0 12px 30px -14px rgba(91,46,140,.6)}'
        + '.ss-main #sensei-studio .sp-crop-dialog .sp-editor{background:#f1eafa}'
        + '.ss-main #sensei-studio .sp-crop-dialog .sp-range-label{color:#3a2a50;font-weight:600}'
        + '.ss-main #sensei-studio .sp-crop-dialog .sp-zoom-value{color:#5b2e8c;font-weight:800}'
        + '.ss-main #sensei-studio .sp-crop-dialog input[type=range]{accent-color:#8b5dbe}'
        + '.ss-main #sensei-studio .sp-crop-dialog .sp-actions button{border:1.5px solid #d9c8f0;background:#f7f2fd;color:#5b2e8c;font-weight:700;border-radius:10px}'
        + '.ss-main #sensei-studio .sp-crop-footer{background:#fff;border-top:1px solid #eee4f8}'
        + '.ss-main #sensei-studio .sp-crop-footer [data-action=crop-cancel]{border:1.5px solid #cdb6ea;background:#fff;color:#5b2e8c;font-weight:700;border-radius:10px}'
        + '.ss-main #sensei-studio .sp-crop-footer .sp-crop-save{background:#5b2e8c;color:#fff;border:0;font-weight:800;border-radius:10px;text-transform:uppercase;letter-spacing:.04em;box-shadow:0 8px 18px -8px rgba(91,46,140,.8)}'
        + '.ss-main #sensei-studio .sp-crop-dialog button:focus-visible,.ss-main #sensei-studio .sp-crop-dialog input:focus-visible{outline:3px solid #b597f6}'
        + '</style>'
        + '<script>document.addEventListener("click",function(e){var b=e.target.closest&&e.target.closest("[data-ss-inbuy]");var h=window.frameElement&&window.frameElement.closest("sensei-shopify");if(e.target.closest&&e.target.closest("[data-ss-share]")&&h&&h.shareDesign){e.preventDefault();h.shareDesign();return;}if(e.target.closest&&e.target.closest("[data-view=crop]")&&h&&h.fitCrop){setTimeout(function(){h.fitCrop();},40);}if(!b||b.disabled)return;if(h&&h.inFrameBuy)h.inFrameBuy(b.dataset.ssInbuy);});</script>'
        + '<script>window.SENSEI_ASSET_BASE="'+meta.base+'";window.SENSEI_ALLOWED_PARENTS=["'+location.origin+'"];'
        + 'window.SENSEI_EMBED={parent:"'+location.origin+'",channel:"'+channel+'"};</script>'
        + skripte
        + '</head><body>'+tpl.innerHTML+'</body></html>';
    }
    disconnectedCallback(){
      clearTimeout(this.connectionTimer);this.abort?.abort();
      if(this.pending){clearTimeout(this.pending.timer);this.pending.reject(new Error('removed'));this.pending=null;}
      this.initialized=false;
    }
    connection(text,error=false){const el=this.q('[data-connection]');if(!el)return;el.textContent=text;el.hidden=!text;el.dataset.error=String(error);}
    post(type,extra={}){if(this.origin)this.frame.contentWindow?.postMessage({protocol:'sensei:v1',channel:this.channel,type,...extra},this.origin);}
    receive(event){
      const data=event.data;
      if(event.source!==this.frame.contentWindow||event.origin!==this.origin||data?.protocol!=='sensei:v1'||data.channel!==this.channel)return;
      if(data.type==='ready'){clearTimeout(this.connectionTimer);this.connection('');this.post('sync');}
      if(data.type==='resize'&&Number.isFinite(data.height)){this.frame.style.height=Math.max(350,Math.min(2200,Math.ceil(data.height)))+'px';setTimeout(()=>this.placeBundle(),30);}
      if(data.type==='state'){
        const state=data.state;
        if(!state||typeof state.ready!=='boolean'||typeof state.color!=='string'||typeof state.scent!=='string'||typeof state.photoId!=='string')return;
        this.latest=state;
        if(/[?&]dizajn=1/.test(location.search)&&state.ready&&state.photoId&&this.savedPhoto===undefined)this.savedPhoto=state.photoId;
        if(!this.unsaved())this.hideAddFirst();
        /* sačuvan nacrt (npr. posle osvežavanja) odmah prikazuje mockup umesto galerije */
        /* na početnoj (skriven konfigurator) mockup se otvara tek kad kupac izabere sliku */
        /* dolazak iz korpe (?dizajn=1): sačuvani dizajn se odmah otvara i na početnoj, sa istom slikom, bojom i mirisom */
        const nastavi=/[?&]dizajn=1/.test(location.search);
        if(state.photoId&&state.ready&&!this.injecting&&(nastavi||!(this.hasAttribute('data-hidden-intro')&&this.dataset.stage!=='studio'))){
          const prvi=this.dataset.stage!=='studio';this.showStudio(true,nastavi&&prvi);
          document.documentElement.classList.remove('ss-nastavi');
          if(nastavi&&prvi){try{const u=new URL(location.href);u.searchParams.delete('dizajn');history.replaceState(history.state,'',u.pathname+u.search+u.hash);}catch(e){}}
        }
        this.updatePurchase();
        this.dispatchEvent(new CustomEvent('sensei:state',{bubbles:true,detail:{state}}));
      }
      if((data.type==='export-result'||data.type==='export-error')&&this.pending?.id===data.requestId){
        const pending=this.pending;this.pending=null;clearTimeout(pending.timer);
        if(data.type==='export-error')pending.reject(new Error(data.message));
        else pending.resolve(data);
      }
    }
    variant(state=this.latest){
      if(!state)return null;
      const extra={};this.querySelectorAll('[data-option]').forEach(el=>extra[Number(el.dataset.option)]=el.value);
      return resolveVariant(this.config,state,extra);
    }
    updatePurchase(){
      if(!this.form||!this.config)return;
      this.syncFrameBuy();
    }
    exportDesign(){
      if(this.pending||!this.latest?.ready||!this.latest?.scent)return Promise.reject(new Error('Prvo završi fotografiju i izaberi parfem.'));
      const id=crypto.randomUUID();
      return new Promise((resolve,reject)=>{
        const timer=setTimeout(()=>{this.pending=null;this.post('export-release');reject(new Error('Priprema fotografije traje predugo. Pokušaj ponovo.'));},20000);
        this.pending={id,resolve,reject,timer};this.post('export-request',{requestId:id});
      });
    }
    releaseDesign(){this.post('export-release');}
    /* izvoz ume da padne dok AI kadar završava — jedan tihi ponovni pokušaj */
    async exportSafe(){try{return await this.exportDesign();}catch(e){this.releaseDesign();await wait(900);return await this.exportDesign();}}
    attach(selector,blob,name){
      if(!(blob instanceof Blob)||!/^image\/(jpeg|png)$/.test(blob.type)||blob.size===0||blob.size>20*1024*1024)throw new Error('Datoteka fotografije nije ispravna.');
      const transfer=new DataTransfer();transfer.items.add(new File([blob],name,{type:blob.type}));
      const input=this.q(selector);input.files=transfer.files;if(input.files.length!==1)throw new Error('Pregledač nije priložio fotografiju.');
    }
    async addDesign(d){
      const id=crypto.randomUUID();
      const ext=b=>b.type==='image/png'?'.png':'.jpg';
      this.attach('[data-crop-file]',d.crop,'sensei-'+id+'-kadar'+ext(d.crop));
      this.attach('[data-source-file]',d.source,'sensei-'+id+'-fotografija'+ext(d.source));
      this.q('[data-variant]').value=d.variantId;this.q('[data-color]').value=d.state.color;this.q('[data-scent]').value=d.state.scent;
      const hexInput=this.q('[data-color-hex]');if(hexInput)hexInput.value=/^#[0-9a-f]{3,8}$/i.test(d.state.hex||'')?d.state.hex:'';
      this.q('[data-design]').value=id;
      /* stranica na kojoj kupac poručuje — korpa ga na nju vraća za sledeći komad */
      const pg=this.q('[data-page]');if(pg){const vw=new URLSearchParams(location.search).get('view');pg.value=location.pathname+(vw?'?view='+encodeURIComponent(vw):'');try{localStorage.setItem('sensei-strana',JSON.stringify({p:pg.value,t:Date.now()}));}catch(e){}}this.q('[data-crop]').value=JSON.stringify({...d.state.crop,sourceWidth:d.state.width,sourceHeight:d.state.height,output:2048});
      const qty=this.form.querySelector('input[name="quantity"]');if(qty)qty.value='1';
      const res=await fetch(this.txt.cartAdd||'/cart/add.js',{method:'POST',body:new FormData(this.form),headers:{Accept:'application/json'}});
      if(!res.ok)throw new Error('Komad nije dodat u korpu. Pokušaj ponovo.');
      try{return await res.json();}catch(e){return {};}
    }
    /* svaki komad posebno: izvoz → korpa → potvrda odmah; kockice i broj stižu u pozadini */
    async submit(event){
      event.preventDefault();event.stopImmediatePropagation();if(this.busy||this.injecting)return;
      let variant=null;try{variant=this.variant();}catch(e){}
      if(!this.latest?.ready||!this.latest.scent||!variant?.available)return;
      const free=this.isFreeNext();
      this.busy=true;this.form.inert=true;this.status('');this.syncFrameBuy();
      try{
        const data=await this.exportSafe();
        const confirmed=this.variant(data.state);if(!confirmed?.available)throw new Error('Izabrana kombinacija nije dostupna.');
        this.form.inert=false;
        const item=await this.addDesign({crop:data.crop,source:data.source,state:data.state,variantId:confirmed.id});
        this.releaseDesign();
        const shown=this.config.variants.find(v=>String(v.id)===String(confirmed.id))||{};
        const guess=typeof this.cartCount==='number'?this.cartCount+1:null;
        if(window.SENSEI&&window.SENSEI.showAdded){
          window.SENSEI.showAdded({
            image:URL.createObjectURL(data.crop),
            name:item.product_title||this.txt.productTitle||'',
            meta:[data.state.color,data.state.scent].filter(Boolean).join(' / '),
            price:free?(this.txt.freePrice||'BESPLATNO'):(shown.price||''),compare:free?(shown.price||''):(shown.compare||''),count:guess
          });
        }
        if(this.latest&&this.latest.photoId)this.savedPhoto=this.latest.photoId;this.hideAddFirst();
        this.busy=false;this.updatePurchase();
        this.loadCart().then(cart=>{if(!cart)return;const c=document.querySelector('[data-added-count]');if(c)c.textContent=cart.item_count;});
      }catch(error){
        this.releaseDesign();this.status(error.message||'Slanje nije uspelo. Pokušaj ponovo.',true);
      }finally{
        this.busy=false;this.form.inert=false;this.updatePurchase();
      }
    }
    /* fotografija izabrana na početnoj strani (dugme u heroju) stiže ovde preko IndexedDB */
    async takeHandoff(){
      const params=new URLSearchParams(location.search);if(!params.has('foto'))return;
      const izgled=params.has('izgled');
      params.delete('foto');params.delete('izgled');const qs=params.toString();
      try{history.replaceState(history.state,'',location.pathname+(qs?'?'+qs:'')+location.hash);}catch(e){}
      let rec=null;
      try{
        rec=await new Promise(res=>{
          const r=indexedDB.open('sensei-handoff',1);
          r.onupgradeneeded=()=>r.result.createObjectStore('files');
          r.onerror=()=>res(null);
          r.onsuccess=()=>{const db=r.result,tx=db.transaction('files','readwrite'),st=tx.objectStore('files'),g=st.get('photo');
            g.onsuccess=()=>{st.delete('photo');res(g.result||null);};g.onerror=()=>res(null);tx.oncomplete=()=>db.close();};
        });
      }catch(e){rec=null;}
      if(!rec||!rec.buf||Date.now()-(rec.at||0)>30*60*1000)return;
      const file=new File([rec.buf],rec.name||'fotografija.jpg',{type:rec.type||'',lastModified:rec.at});
      await this.sendPhoto(file);
      if(izgled&&this.dataset.stage==='studio')await this.lookFromCart();
    }
  }
  customElements.define('sensei-shopify',SenseiShopify);
})();
